import * as React from "react";
import { imagens } from "../../Func_genericas/valores_estaticos";


export default function LoadingVulpesSmall() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        // minHeight: "100vh",
      }}
    >
      <img
        src={imagens.loader_gif}
        alt="Loading"
        style={{ width: "80px", height: "100px" }}
      />
    </div>
  );
}
